import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { CopyBlock, dracula } from "react-code-blocks";
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";




const JavaScriptLesson4 = () => {
  const [language, changeLanguage] = useState("html");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `<body>
  <script>
  console.log('Hello World!');
  </script>
  </body>
  `
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Placement of JavaScript</strong></h3>
    <p>JavaScript is typically placed at the bottom of your web page. There are times although when it is placed wihin the <b class="text-danger">&lt;head&gt;</b> tag </p>
    <p class="mb-4">Let's write a simple <b>Hello World</b> program and debug in our browser.</p>
    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
      />
      {/*<img src={hello} class="img-fluid mb-4" />
      <p>Next, right-click anywhere on your webpage and inspect the element. You should see the result on the console.</p> */}
     <div style={{ height: 450 }} />

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson4
